import React, { useEffect } from "react";
import Logo from "../../common/Logo";
import { useLocation, useNavigate } from "react-router-dom";

// responsive assets (generate with scripts/generate-images.js)
import success480Webp from "../../../assets/success-480.webp";
import success800Webp from "../../../assets/success-800.webp";
import success1200Webp from "../../../assets/success-1200.webp";
import success480Jpg from "../../../assets/success-480.jpg";
import success800Jpg from "../../../assets/success-800.jpg";
import success1200Jpg from "../../../assets/success-1200.jpg";

import tickImg from "../../../assets/tick.png";

const Success = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!location.state || !location.state.fromSetPassword) {
      navigate("/SignIn");
    }
  }, [location, navigate]);

  return (
    <section className="bg-tg-bg py-12 lg:py-[50px] min-h-screen">
      <div className="container mx-auto">
        <div className="flex justify-center mb-8">
          <Logo />
        </div>

        <div className="bg-white rounded-lg overflow-hidden shadow-md">
          <div className="flex flex-col lg:flex-row items-stretch">
            {/* visual / banner - stacks above on small, left column on lg */}
            <div className="w-full lg:w-1/2">
              <picture>
                <source
                  type="image/webp"
                  srcSet={`${success480Webp} 480w, ${success800Webp} 800w, ${success1200Webp} 1200w`}
                  sizes="(max-width: 640px) 480px, (max-width: 1024px) 800px, 1200px"
                />
                <source
                  type="image/jpeg"
                  srcSet={`${success480Jpg} 480w, ${success800Jpg} 800w, ${success1200Jpg} 1200w`}
                  sizes="(max-width: 640px) 480px, (max-width: 1024px) 800px, 1200px"
                />
                <img
                  src={success1200Jpg}
                  alt="Success banner"
                  loading="lazy"
                  className="w-full h-40 sm:h-64 lg:h-[600px] object-cover"
                />
              </picture>
            </div>

            {/* content */}
            <div className="w-full lg:w-1/2">
              <div className="w-full px-6 py-12 sm:p-14 lg:p-20 flex items-center justify-center">
                <div className="max-w-md w-full text-center">
                  <div className="mx-auto w-[69px] h-[69px]">
                    <img
                      src={tickImg}
                      alt="Success"
                      className="w-full h-full object-contain mx-auto"
                      loading="lazy"
                    />
                  </div>

                  <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-dark mt-4">
                    Password changed successfully!
                  </h2>

                  <p className="mt-3 text-base text-slate-800">
                    You can now continue to sign in.
                  </p>

                  <div className="mt-8">
                    <button
                      onClick={() => navigate("/SignIn")}
                      type="button"
                      className="w-full rounded-md border border-primary bg-primary text-base py-3 text-white transition hover:bg-opacity-90"
                    >
                      Sign In
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Success;

const InputBox = ({ type, name, labelTitle }) => {
  return (
    <div className="mt-5">
      <label className="mb-2.5 block text-base text-dark dark:text-white font-medium">
        {labelTitle}
      </label>
      <input
        type={type}
        name={name}
        className="w-full rounded-md border border-[#E9EDF4] bg-transparent px-5 py-3 text-body-color outline-none focus:border-primary focus-visible:shadow-none dark:border-dark-3 dark:text-white"
      />
    </div>
  );
};
